import type { ContainerModuleLoader } from '@wix/thunderbolt-ioc'
import { LifeCycle } from '@wix/thunderbolt-symbols'
import {
	LogicalReflectorSymbol,
	PageProviderSymbol,
	PageStructureJsonSymbol,
	PagePropsJsonSymbol,
	PageInitializerSymbol,
	InitPagePhasesSymbol,
} from './symbols'
import type { IPageProvider, IPageReflector, IPageInitializer, IInitPagePhases } from './types'
import { PageProvider } from './PageReflector'
import { LogicalReflector } from './logicalReflector'
import PageBiReporting from './pageBiReporting'
import { PageInitializer } from './pageInitializer'
import { InitPagePhases } from './initPagePhases'

export const site: ContainerModuleLoader = (bind) => {
	bind<IPageProvider>(PageProviderSymbol).toProvider<IPageReflector>(PageProvider)
	bind(LogicalReflectorSymbol).toProvider<IPageReflector>(LogicalReflector)
	bind(LifeCycle.AppDidMountHandler).to(PageBiReporting)
	bind(PageInitializerSymbol).to(PageInitializer)
	bind(InitPagePhasesSymbol).to(InitPagePhases)
}

export {
	PageProviderSymbol,
	LogicalReflectorSymbol,
	PageStructureJsonSymbol,
	PagePropsJsonSymbol,
	IPageProvider,
	IPageReflector,
	IPageInitializer,
	IInitPagePhases,
	PageInitializerSymbol,
	InitPagePhasesSymbol,
}
